module.exports = __webpack_public_path__ + "img/tencent.f77bc704.jpg";